var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgHddv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 18V17V5C36 3.89543 35.1046 3 34 3H11C9.89543 3 9 3.89543 9 5V34C9 35.1046 9.89543 36 11 36H20.5V19.1476C20.5 18.5135 21.0289 18 21.682 18H36Z",
    fill: "#4570FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24V17L4.5 20L9 24Z",
    fill: "#1BA2D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9836 28.317L7.79412 22.4662L4.5 20V41H8.02605H10.0859L20.5 40.8967V39.236V36.7699V32.824L14.9836 28.317Z",
    fill: "#73D7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3108 20V42.0077H39.3707C39.3707 41.0393 38.5829 40.2278 37.6076 40.2278C36.6322 40.2278 35.8444 41.0393 35.8444 42.0077H33.6686C33.6686 41.0393 32.8808 40.2278 31.9054 40.2278C30.93 40.2278 30.1422 41.0393 30.1422 42.0077H27.9664C27.9664 41.0393 27.1786 40.2278 26.2032 40.2278C25.2278 40.2278 24.44 41.0393 24.44 42.0077H22.5V20H41.3054H41.3108Z",
    fill: "#00ACEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7435 34.737L34.2537 31.5542H24.5V29.6068H34.2484L30.7435 26.4239L32.1047 25L38.2517 30.5805L32.1047 36.1661L30.7435 34.737Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#FFDD64"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#FFDD64"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#FFDD64"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHddv);
export default __webpack_public_path__ + "static/media/img_hddv.09583ade508e88dabf594e86f29aa4c6.svg";
export { ForwardRef as ReactComponent };